import { render, staticRenderFns } from "./SuggestionView.vue?vue&type=template&id=42fab2a9&"
import script from "./SuggestionView.vue?vue&type=script&lang=js&"
export * from "./SuggestionView.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports